export default {
  route: {
    dashboard: '首页',
    productService:'产品服务',
    securityPost:'安全岗哨',
    sassPlatform:'SasS平台',
    intelligent:'智能装备',
    solution:'解决方案',
    coldChain:'冷链流通行业',
    raiseLivestock:'畜牧养殖行业',
    aquaticProduct:'水产养殖行业',
    fruiter:'果蔬种植行业',
    aboutus:'关于我们',
    contactus:'联系我们',
    followus:'关注我们',
    login:'登录'
  },
  footer:{
    email:'邮箱',
    phone:'电话',
    address:'地址',
    emailInfo:'xiaoohai@daovay.com',
    phoneInfo:'400-015-1656',
    addressInfo:'深圳市福田区华强北街道福强社区振华路中电迪富大厦7层',
	  wx:'公众号',
  },
  index:{
    environment:'存储环境安全可见',
    circulation:'流通追溯安全可见',
    quality:'生长过程安全可见',
    product:'产',
    storage:'仓',
    distriution:'配',
    sale:'出',
    safety:'安全',
    health:'健康',
    nutrition:'营养',
    mapintro1:'哨冰是领先的食品安全数字化服务运营商，专注于食品安全产业物联网应用，致力于构建食品安全产业的物联网基础设施。',
    mapintro2:'哨冰构建起从种植养殖、加工生产到终端消费的食品流通全链条、可追溯的安全防护体系。业务覆盖全国及周边亚洲国家、非洲部分地区，技术实力得到国内和国际用户认可。',
    new1:'更精准的把控紫外线消毒的全过程，采用哨冰紫外线采集器方案，可数字化的监控和操作紫外线杀菌，提升紫外线消毒效率和安全性',
    new2:'“哨冰商城”已正式上线，为食品流通相关产业从业者提供一个连接上游原产地到下游零售商的信息交流平台，可下载哨冰APP免费试用。',
    new3:'水果蔬菜等从田间地头到餐桌的这一过程，可能涉及到冷藏库、冷藏车、冷藏箱、冷藏柜等多个存储流通的设施场景，任何一个环节做的不到位，就有可能导致食物的不新鲜，产生不必要的损失和代价。哨冰的出现，就是为了提前预判，减少损失，为食品安全站岗放哨。',
    new4:'哨冰3D监控场景，不受时间、空间、地点、条件、对象的限制，可根据个人的使用习惯，模拟走位，查询的设备安装点，查看设备运行情况以及周边温湿度等详细参数。',
    new5:'哨冰IOT设备实时感知水果蔬菜等农副产品的生长、存储、运输过程中的温湿度、二氧化碳、氧气、光照等环境数据，同时可通过手机对冷机、风机等进行远程无线操作。数据全程可追溯，为食品流通过程提供更多具有实操价值的数据化的模型。',
    tips1:'以物联网技术创新为依托',
    tips2:'为食品安全站岗放哨',
    tips3:'预约体验',
    swiper3:'哨冰构建起从种植养殖、加工生产到终端消费的食品流通全链条、可追溯的安全防护体系。'
  },
  sercurity:{
    title1:'安全岗哨',
    title2:'为食品安全站岗放哨',
    Humtemp:'哨冰 · 安全岗哨',
    HumtempT:'从食品的生产源头到消费者末端全程扫描，信息持续监控回传，安全防护',
    scan:'安全扫描',
    application:'应用加固',
    components:'安全组件',
    monit:'实时监控',
    analysis:'数据分析',
    scanTitle:'实时、准确、急速监测上报每一处细节',
    scanTitle1:'快速响应',
    scanicon1:'食品从源头到消费者的餐桌上，经历着温度、湿度、以及气体等条件的严格限制，哨冰可实时监测每一种条件。',
    scanicon2:'智能预断',
    scanicon3:'哨冰将每一次的种植、捕捞、配送预案提前做好，让新鲜的食材在可控的移动环节上显现的更加详细准确，同时也将食品的新鲜做到了安全。',
    scanicon4:'多元场景',
    scanicon5:'如何让鲜花、帝王蟹、樱桃…在不同场景下长时间新鲜储存，哨冰根据不同动植物的生态配合做出了智能多元化场景。',
    appliTitle:'融合多种生态链系统，应用范围更全面',
    appliTitle1:'领域更广',
    appliTitle2:'全面加固',
    appliicon1:'畜牧养殖业',
    appliicon2:'温湿度适宜，光照通风，水草丰茂，水源干净，无浓烟的地方更适合畜牧业的养殖。',
    appliicon3:'水产养殖业',
    appliicon4:'水中的矿物质、氧气浓度，水温随时影响水产养殖业的投入产出。',
    appliicon5:'瓜果蔬种植业',
    appliicon6:'水果，烟草，蔬菜，花卉每一个产业都在关注如何保鲜保质量。',
    appliicon7:'饮料奶制品行业',
    appliicon8:'地方特色的风味饮品与新鲜奶制品的整条生态链对环境的要求是非常高的。',
    appliicon9:'冷链运输产业',
    appliicon10:'当食品经过了仓、车、柜等储存设备，期间的温湿度、光感、气体浓度详细可现。',
    comTitle:'多功能物联网产品，兼容更多设备相连接',
    comTitle1:'高度集成',
    comTitle2:'工业智造',
    temp:'温度',
    tempInfo:'从原产地经营方到冷链企业,从食品加工制造企业到中大型零售商，哨冰可做到超宽温监测。',
    rh:'湿度',
    rhInfo:'大棚种植和无土化栽培技术的日渐成熟，哨冰可长时间经受IP67等级考验。',
    gas:'气体',
    gasInfo:'水果、蔬菜、花卉的生长运输过程中，二氧化碳，乙烯等气体尤为重要。',
    uv:'紫外线',
    uvInfo:'植物的定点光照和指定设备的紫外线消毒可以提高产量和健康的生活环境。',
    location:'冷链运输产业',
    locationInfo:'食品等消费品定点的运送和运输线路的确定，可以提高工作效率和消费水平。',
    monitTitle:'从应用安全、应用环境到应用异常三方面全生命周期进行实时监控',
    monitTitle1:'7*24工作',
    monitTitle2:'智能监测',
    moniticon1:'应用安全',
    moniticon2:'哨冰安全岗哨提供数字化安全服务，从软硬件部署到各监测点信息采集，再到后续的信息提醒，安全岗哨做到了从电脑端到手机端再到场景模拟全方位安全应用。',
    moniticon3:'应用环境',
    moniticon4:'哨冰安全岗哨为了避免不同应用环境出现的信息缺漏情况，采用了本地存储、云端存储、个人操作三方面存储，确保数据的完整性和可靠性。',
    moniticon5:'异常监测',
    moniticon6:'温湿度强度、光感时长、气体浓度等条件因素的不合理，安全岗哨会将异常情况及时显现给处理人员，并且给指定的人员传输相关的处理信息和处理结果。',
    anaTitle:'利用高效的数据分析功能，提高效率',
    anaTitle1:'安全统计',
    anaTitle2:'数字运营',
    anaicon1:'安全评估',
    anaicon2:'哨冰安全岗哨根据使用的习惯和场景需要，提前对各项数据提前预估和计算。',
    anaicon3:'数字应用',
    anaicon4:'安全岗哨的呈现是环境数字化可视，货物数字化可视，人员数字化可视。',
    anaicon5:'渗透分析',
    anaicon6:'每一个数据的差别都将是一个重要的节点，哨冰安全岗哨高效渗透分析为您和您的监测点保驾护航。',
    anaicon7:'安全流程',
    anaicon8:'每一个节点的报警请求到处理过程和结果整个流程的安全，都将经过哨冰岗哨的筛查。',
                                                                                             
}, 
Solution:{
    IndustryPainPoints:'行业痛点',
    SolutionArchitecture:'方案架构',
    TypicalScene:'典型场景',
    SolutionAdvantage:'方案优势',
    RelatedDocuments:'相关文档',

    ColdChainSolution:'冷链流通行业解决方案',
    LivestockBreeding:'畜牧养殖行业解决方案',
    Aquaculture:'水产养殖行业解决方案',
    FruitAndVegetablePlanting:'果蔬种植行业解决方案',

    //方案架构图片标题描述
    SolutionArchitectureTitle:'以物联网基础为核心的SaaS云服务平台',

    AdvantageFirstTitle:'多年行业经验',
    AdvantageFirstContent:'共享哨冰尖端技术，多年安全运营实践经验',
    AdvantageSecondTitle:'场景化解决方案定制',
    AdvantageSecondContent:'安全策略灵活定制，匹配业务场景,设计安全解决方案',
    AdvantageThreeTitle:'7 * 24小时监视',
    AdvantageThreeContent:'全方位检测，实时准确上报各项数据，智能分析显示',
    AdvantageFourthTitle:'资深行业团队支持',
    AdvantageFourthContent:'百余人顶尖安全专家团队，1对1匠心服务保障'
  },
  //冷链解决方案
  ColdChainSolution:{
    Title:'冷链流通行业解决方案',
    Detail:'温度、湿度、气体、定位等信息实时监测、急速上报、准确分析每一处细节',

    IndustryPainPointsFirstTitle:'"冷链"变"冷端"',
    IndustryPainPointsFirstContent:'冷链物流不同于其他普通物流，冷链物流更注重从每一个链条，每一个时间点出发，严格把控周围环境，目前冷链市场对冷链两端比较注重，对于冷链中间流通环节比较薄弱。',
    IndustryPainPointsSecondTitle:'溯源不健全',
    IndustryPainPointsSecondConetnt:'单一的温湿度检测无法做到冷链流通产品的优化，从车辆到驾驶员，从运输的物品到被需要检测的信息，都需要建立健全。',
    IndustryPainPointsThreeTitle:'产业不物联',
    IndustryPainPointsThreeContent:'目前冷链流通行业对温湿度、光感、气体的判断仅存在于车辆本身，无法将监测信息实时、准确的呈现给需要的人群，产业的物联网化比较薄弱。',

    TypicalSceneIconFirstTitle:'熟食加工',
    TypicalSceneIconSecondTitle:'仓库保鲜',
    TypicalSceneIconThreeTitle:'冷链配送',
    TypicalSceneIconFourthTitle:'店面零售'
  },
  //畜牧解决方案
  LivestockBreeding:{
    Title:'畜牧养殖行业解决方案',
    Detail:'温度、湿度、光照、氨气、二氧化碳、H2S等信息实时监测、急速上报、准确分析每一处细节',

    IndustryPainPointsFirstTitle:'温湿度未能物理网化',
    IndustryPainPointsFirstContent:'畜禽消化缓慢，进食量降低；抵抗力会下降，出现脱水严重，肠胃等疾病。需要对环境中的温湿度进行实时的调整。',
    IndustryPainPointsSecondTitle:'气体环境缺乏感知',
    IndustryPainPointsSecondConetnt:'在炎热的夏季，圈养栏中的氨气，硫化氢含量增加，被圈养的畜禽容易在高温环境中产生疾病，合理的检测圈养栏里的环境是很有必要的。',
    IndustryPainPointsThreeTitle:'产业效率低下',
    IndustryPainPointsThreeContent:'光照度的强弱，光照时间的长短等对畜禽生长发育、成活率及对"产蛋"多少起着至关重要的作用，适宜的光照时间与光照强度能使家禽发挥其良好的生长、生产性能。',

    TypicalSceneIconFirstTitle:'生态养畜',
    TypicalSceneIconSecondTitle:'智慧养畜',
    TypicalSceneIconThreeTitle:'鸟类圈养',
    TypicalSceneIconFourthTitle:'蛋类产出'
  },
  //水产解决方案
  Aquaculture:{
    Title:'水产养殖行业解决方案',
    Detail:'水溶、溶解氧（DO）、水体透明度等理化数据实时监测、急速上报、准确分析每一处细节。',

    IndustryPainPointsFirstTitle:'缺少环境信息判断',
    IndustryPainPointsFirstContent:'水产养殖行业不同种类的鱼虾蟹生长环境不同，在不适宜温度条件下，不仅生长受到影响， 还会出现异常反应，甚至死亡。',
    IndustryPainPointsSecondTitle:'养殖仅靠日常规律',
    IndustryPainPointsSecondConetnt:'水中氧气主要通过水与气界面的氧气扩散和水中植物光合作用产生氧这两种方式，同样与水温、时间、气压、风力、流动等因素有关，溶氧量的多少没有科学依据。',
    IndustryPainPointsThreeTitle:'产业利用效率低',
    IndustryPainPointsThreeContent:'对水产养殖水体而言，水体透明度的大小，大体可以表示水中浮游生物量的多少和水质肥瘦的程度，刮风、降水和水的流动速度也会影响到水体的浑浊度与透明度，水产的生长与此有着重要的关系。',

    TypicalSceneIconFirstTitle:'稻渔种养',
    TypicalSceneIconSecondTitle:'智慧渔场',
    TypicalSceneIconThreeTitle:'休闲渔业',
    TypicalSceneIconFourthTitle:'鱼菜共生'
  },
  //果蔬解决方案
  FruitAndVegetablePlanting:{
    Title:'果蔬种植行业解决方案',
    Detail:'气温、湿度、积温、有效积温、日照时长、二氧化碳浓度等实时、准确、急速检测上报分析每一处细节。',

    IndustryPainPointsFirstTitle:'信息条件缺乏',
    IndustryPainPointsFirstContent:'目前部分市场针对果蔬生长环境判断有限，合理控制温度，光照管理，科学的肥水控制和疾病控制是冬季温度管理和高产的关键。',
    IndustryPainPointsSecondTitle:'思路缺少探索',
    IndustryPainPointsSecondConetnt:'无法远程查看果蔬生长环境及生长情况，可能发生种植的作物窒息、变色、腐烂，导致土壤缺氧，并对周围区域内的作物产生不良影响。',
    IndustryPainPointsThreeTitle:'产业利用效率低',
    IndustryPainPointsThreeContent:'无法科学果蔬种植，导致从育种到栽培，从种植到采摘都无法做到最大产出效率，导致产能降低的现象出现。',

    TypicalSceneIconFirstTitle:'瓜果种植',
    TypicalSceneIconSecondTitle:'花卉养殖',
    TypicalSceneIconThreeTitle:'特种育苗',
    TypicalSceneIconFourthTitle:'蔬菜种植',
    TypicalSceneIconFifthTitle:'无土培养',
    TypicalSceneIconSixthTitle:'药材种植'
  },
  AboutUs:{
    Title:'致力于构建食品安全产业的物联网基础设施',
    Values:'价值观',

    SecondContent1:'哨冰是领先的食品安全数字化服务运营商，专注于食品安全产业物联网应用，致力于构建食品安全产业的物联网基础设施。构建起从种植养殖、加工生产到终端消费的食品流通全链条、可追溯的安全防护体系。',
    SecondContent2:'通过智慧物联技术对食品流通全过程所经历的棚、仓、车、柜、箱等场景化下所需感知的温度、湿度、位置、图像、传感控制等相关动态数据准确连贯地记录，并提供实时多级预警，为食品流通全生命周期提供有效的安全保障。',

    ThreeContentLeft1:'愿景',
    ThreeContentRight1:'成为最受信赖的食品安全产业物联网服务运营商',
    ThreeContentLeft2:'使命',
    ThreeContentRight2:' 以物联网技术创新为依托，为食品安全站岗放哨',

    FourthSpanTitle1:'尊重用户',
    FourthSpanContent1_1:'和客户交朋友，敬畏用户和行业，让产品简单可依赖是我们的追求;',
    FourthSpanContent1_2:"客户需求是公司策略决策的最重要来源，帮客户解决问题是我们生存之本",
    FourthSpanTitle2:'合作共赢',
    FourthSpanContent2_1:'以利他和共赢的态度面对产业链合作伙伴和团队同事，乐意为伙伴的成功喝彩',
    FourthSpanContent2_2:'团队作战共享共担，以真诚开放的心态，换位思考，坦诚沟通。',
    FourthSpanTitle3:'独立思考',
    FourthSpanContent3_1:'敢于质疑，有整合分析问题的能力，但切忌不懂装懂；',
    FourthSpanContent3_2:'经常复盘自省，从失败中成长.',
    FourthSpanTitle4:'乐观热情',
    FourthSpanContent4_1:'对高傲冷漠说不，积极主动友好地面对工作和生活，经常鼓励他人;',
    FourthSpanContent4_2:'不传播负面情绪，对待任何事情都有一种积极向阳的态度.',
    FourthSpanTitle5:'正直踏实',
    FourthSpanContent5_1:"诚实守信，心存善念，不在背地里搞小动作.",
    FourthSpanContent5_2:'敬业，有勇气做正确的事情，做长期主义者。',

    BackgroundJoin:'欢迎加入哨冰~',

    FootSpanTitle1:'商业合作',
    FootSpanTitle2:'媒体沟通',
    FootSpanTitle3:'商业咨询',
    FootSpanTitle4:'安全反馈',
    FootSpanTitle5:'业务咨询',
    FootSpanContent5_1:'周一到周五',

    FootSpanTitle6:'公司地址',
    FootSpanContent6_1:'运营总部：深圳市福田区振华路中电迪富大厦7楼',
    FootSpanContent6_2:"研发总部：西安市雁塔区科技二路清华科技园D座5楼",

    DialogTitle1:'商业合作',
    DialogTitle2:'招贤纳才',
    DialogName:'姓名',
    DialogPhone:'电话',
    DialogRemark:'备注',
    DialogClose:'取消',
    DialogConfirm:'确认',

    rulesValidate1:"请输入用户名",
    rulesValidate2:"请留下您的联系方式",
  }
}
